import React from "react";
import Navbar from "../pages/Navbar";
import "../styles/contact.css";

const Contact = () => {
    return (
        <div className="page-wrapper">
            <Navbar />

            <main>
                <div className="krishtech1">
                   
                        <h1>Contact Information</h1>
                    

                    <p><strong>Company :</strong> KrishTech Software</p>
                    <p>
                        <strong>Website :</strong>
                        <a href="https://www.krishtechsoftware.com" target="_blank" rel="noopener noreferrer">
                            www.krishtechsoftware.com
                        </a>
                    </p>

                    <h2><strong>Name :</strong> Murali Thadi</h2>
                    <p><strong>Designation :</strong> Tech Lead (12+ Years of IT Experience)</p>

                    <h2>Contact Details</h2>
                    <p>
                        <strong>Email :</strong>
                        <a href="mailto:krishtechnosoftware@gmail.com">krishtechnosoftware@gmail.com</a>
                    </p>
                    <p><strong>Mobile 1 :</strong> <a href="tel:+917715958035">+91 7715958035</a></p>
                    <p><strong>Mobile 2 :</strong> <a href="tel:+919705747055">+91 9705747055</a></p>
                </div>
            </main>

            <footer className="footer">
                <div className="text_style">
                    <p>&copy; 2026 KrishTech Software - Your IT Friend. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
};

export default Contact;
